/**
 * Pending Withdraw Model
 */

define(function(require, exports, module) {
    'use strict';
    var BaseModel = require('common/base.model');
    var server = require('server');

    module.exports = BaseModel.extend({

        idAttribute: 'code',

        toJSON: function() {
            const data = BaseModel.prototype.toJSON.call(this);

            data.time = window.Playtech.API.formatter.getDateTimeShort(data.time);
            data.amount = window.Playtech.API.formatter.formatCurrency(data.amount);

            return data;
        },

        sync: function(method, model, options) {
            if (method === 'delete') {
                return server.send({
                    ID: 33020,
                    description: 'Cancel withdraw',
                    responses: [33021, 33022],
                    transactionCode: this.get('code'),
                    reason: ''
                }).done(options.success).fail(options.error);
            }
        }
    });

});
